import { Stack } from "@mui/material";
import { useAuthContext } from "../../../auth/useAuthContext";
import { useLocales } from "../../../locales";

export default function NavDocs() {
  return (
    <Stack
      spacing={3}
      sx={{
        px: 5,
        pb: 5,
        mt: 10,
        width: 1,
        display: "block",
        textAlign: "center",
      }}
    ></Stack>
  );
}
